import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { GeneralService } from '@shared/services/general.service';
import { TokenService } from '@shared/services/token.service';

export const accessGuard: CanActivateFn = (route, state) => {
  const generalService = inject(GeneralService);
  const tokenService = inject(TokenService);

  if (generalService.isBrowserOnly) {
    if (tokenService.getRtk()?.length) {
      return true;
    }
  }
  generalService.router.navigate(['/auth'], {
    queryParams: {
      redirect: state.url,
    },
  });
  return false;
};
